module.exports = __webpack_public_path__ + "static/media/img-app-interview-reminding.ad41a9c9.png";